import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RolesEnum } from '@definitions/role.interface';
import { PackageFeature } from '@definitions/subscription.interface';
import { AuthService } from '@services/auth.service';

export const packageGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isParticular()) {
    return router.createUrlTree(['/overview']);
  }

  const user = authService.user();
  const requireFeature = route.data['requireFeature'] as PackageFeature | undefined;
  const excludeFeature = route.data['excludeFeature'] as PackageFeature | undefined;
  const isSuperAdmin = user?.roles?.includes(RolesEnum.SUPERADMIN) ?? false;
  const features = user?.packages?.flatMap((pkg) => pkg.features) ?? [];

  const passesRequire = !requireFeature || features.includes(requireFeature);
  const passesExclude = !excludeFeature || !features.includes(excludeFeature);

  if (isSuperAdmin || (passesRequire && passesExclude)) {
    return true;
  }

  return router.createUrlTree(['/overview']);
};
